import Vue from "vue";
import { ActionTree, MutationTree, GetterTree } from "vuex";
import { RootState } from "@/store/types";
import { ServerResult } from "@/core/http/server_result";
import { build_query as build_query_catalog } from "../Catalog/_store";
import moment from "moment";

interface OrdersNewState {
  loaded: boolean;
  loading: boolean;
  fatalError: boolean;

  lastMeta: {
    page: number;
    pageSize: number;
    totalCount: number;
    totalPages: number;
  };

  documents: any[];
  holydays: any;
  client: any;
  catalog: any;
  schema: any;
  totalSum: number;
  asyncValidationLoading: boolean;
  hasAsyncError: boolean;
  asyncErrors: any[];
}

const state: OrdersNewState = {
  loading: false,
  loaded: false,
  fatalError: false,

  lastMeta: {
    page: 0,
    pageSize: 0,
    totalCount: 0,
    totalPages: 0
  },

  documents: [],
  holydays: {},
  client: null,
  catalog: {},
  schema: null,
  totalSum: 0,
  asyncValidationLoading: false,
  hasAsyncError: false,
  asyncErrors: []
};

export const DEAL_SCHEMA = "GET_DEAL_SCHEMA";
export const CLIENT_DATA = "GET_CLIENT_DATA";
export const DELIVERY_DATE_DATA = "DELIVERY_DATE_DATA";

const COLUMNS: any = {
  // expected_delivery_date: 'deals.expected_delivery_date',
  delivery_point_id: "deals.delivery_point_id",
  counterparty_id: "deals.counterparty_id",
  products: {
    $array_agg: {
      $obj: {
        product_id: "product_containers.product_id",
        product_container_id: "deal_product_containers.product_container_id",
        container_quantity: "deal_product_containers.container_quantity",
        container_price: "deal_product_containers.container_price",
        container_weight: {
          $mul: [
            "deal_product_containers.container_quantity",
            "product_containers.weight"
          ]
        },
        notes: "deal_product_containers.notes",
        base_price: "personal_settings.container_price",
        base_weight: "product_containers.weight",
        price_per_kg: "product_containers.price_per_kg"
      }
    }
  }
};

export function build_query(query: any) {
  const filter: any[] = [];

  filter.push({
    $eq: ["deals.id", { $: query.copy }]
  });
  return {
    columns: COLUMNS,
    from: "s:deals",
    from_as: "deals",
    joins: [
      {
        join: "s:deal_product_containers",
        type: "left",
        as: "deal_product_containers",
        on: {
          $eq: ["deal_product_containers.deal_id", "deals.id"]
        }
      },
      {
        join: "s:product_containers",
        type: "left",
        as: "product_containers",
        on: {
          $eq: [
            "product_containers.id",
            "deal_product_containers.product_container_id"
          ]
        }
      },
      {
        join: "s:client_product_containers",
        type: "left",
        as: "personal_settings",
        on: {
          $and: [
            {
              $eq: [
                "personal_settings.product_container_id",
                "product_containers.id"
              ]
            },
            { $eq: ["personal_settings.client_id", "deals.client_id"] }
          ]
        }
      }
    ],
    groups: [
      "deals.expected_delivery_date",
      "deals.delivery_point_id",
      "deals.counterparty_id"
    ],
    order: [{ $desc: ["deals.expected_delivery_date"] }],
    ...(filter.length > 1
      ? {
          where: {
            $and: filter
          }
        }
      : {
          where: filter[0]
        })
  };
}

export const actions: ActionTree<OrdersNewState, RootState> = {
  loadDeal({ commit, dispatch, rootState }, query) {
    const vm = (this as any)._vm;
    const client_id = query.client_id
      ? query.client_id
      : (rootState as any).ubic.actor.document.client_id;
    console.log(query);
    vm.$db([
      vm
        .$q(DEAL_SCHEMA)
        .raw("documents.list")
        .action(build_query(query))
    ]).then((result: ServerResult) => {
      dispatch(
        "prepareNew",
        result.getOperation(DEAL_SCHEMA).getContent().documents[0]
      );
    });
  },

  prepareCatalog({ commit, dispatch, rootState }, initParams) {
    const vm = (this as any)._vm;
    const client_id = initParams.client_id
      ? initParams.client_id
      : (rootState as any).ubic.actor.document.client_id;
    return new Promise((resolve, reject) => {
      commit("START_LOADING");
      const client_id = initParams.client_id
        ? initParams.client_id
        : (rootState as any).ubic.actor.document.client_id;

      vm.$db([
        vm
          .$q("CATALOG_LIST")
          .raw("documents.list")
          .action(build_query_catalog({}, client_id, true))
      ])
        .then((result: ServerResult) => {
          commit("SET_CATALOG", {
            client_id: client_id,
            catalog: result.getOperation("CATALOG_LIST").getContent()
          });

          commit("LOADED_SUCCESS");
          resolve(null);
        })
        .catch((error: any) => {
          console.log("error", error);
          commit("LOADED_ERROR");
          reject();
        });
    });
  },

  async getDeliveryDates({ state, commit }, { delivery_point_ids }) {
    const vm = (this as any)._vm;

    return new Promise((resolve, reject) => {
      commit("START_LOADING");

      const promises: any[] = delivery_point_ids.map((item: any) => {
        return vm.$http.get(
          `/api/v1/get_delivery_date_by_delivery_point/${item}`,
          {},
          {}
        );
      });
      Promise.all(promises).then(responses => {
        resolve(
          responses.reduce((acc: any, item: any, idx: any) => {
            acc[idx] = moment(item.data.result);
            return acc;
          }, {})
        );
      });
    });
  },

  getDeliveryDate({ state, commit }, { delivery_point_id }) {
    const vm = (this as any)._vm;

    return new Promise((resolve, reject) => {
      commit("START_LOADING");

      const delivery_date = moment().format("YYYY-MM-DD HH:mm:ss");

      vm.$http
        .get(
          `/api/v1/get_delivery_date_by_delivery_point/${delivery_point_id}/${delivery_date}`,
          {},
          {}
        )
        .then((response: any) => {
          commit("LOADED_SUCCESS");
          resolve(moment(response.data.result).toDate());
        })
        .catch((error: any) => {
          console.log("errror", error);
        });
    });
  },

  setYear({ commit }, { delivery_point_id, delivery_zone_id }) {
    const vm = (this as any)._vm;

    return new Promise((resolve, reject) => {
      commit("START_LOADING_YEAR");
      const start = moment();
      const end = moment(start.year() + "-12-31").format("YYYY-MM-DD");

      const columns: any = {
        id: "delivery_date_holydays.id",
        date: "delivery_date_holydays.date",
        delivery_zone_id: "delivery_date_holydays.delivery_zone_id",
        created_at: "delivery_date_holydays.created_at",
        updated_at: "delivery_date_holydays.updated_at"
      };

      const filter: any[] = [];

      filter.push({
        $gte: ["delivery_date_holydays.date", { $: start.format("YYYY-MM-DD") }]
      });
      filter.push({ $lte: ["delivery_date_holydays.date", { $: end }] });
      filter.push({
        $eq: [
          "delivery_date_holydays.delivery_zone_id",
          { $: delivery_zone_id }
        ]
      });
      filter.push({
        $eq: [
          "delivery_date_holydays.delivery_point_id",
          { $: delivery_point_id }
        ]
      });

      vm.$db([
        vm
          .$q("ITEMS_LIST")
          .raw("documents.list")
          .action({
            columns: columns,
            from: "s:delivery_date_holydays",
            from_as: "delivery_date_holydays",
            page_size: 1000,
            ...(filter.length > 1
              ? {
                  where: {
                    $and: filter
                  }
                }
              : {
                  where: filter[0]
                })
          })
      ]).then((result: ServerResult) => {
        commit("SET_HOLYDAYS", result.getOperation("ITEMS_LIST").getContent());
        commit("LOADED_SUCCESS_YEAR");

        resolve(null);
      });
    });
  },

  prepareNew({ commit, dispatch, rootState }, initParams) {
    const vm = (this as any)._vm;

    return new Promise((resolve, reject) => {
      commit("START_LOADING");
      const client_id = initParams.client_id
        ? initParams.client_id
        : (rootState as any).ubic.actor.document.client_id;

      vm.$db([
        vm
          .$q("CATALOG_LIST")
          .raw("documents.list")
          .action(build_query_catalog({}, client_id, true)),
        vm
          .$q(DEAL_SCHEMA)
          .raw("schemas.get")
          .action({
            id: `s:deals`
          }),
        vm
          .$q(CLIENT_DATA)
          .raw("documents.get")
          .action({
            id: client_id
          })
      ])
        .then((result: ServerResult) => {
          commit("SET_SCHEMA", {
            schema: result.getOperation(DEAL_SCHEMA).getContent(),
            client: result.getOperation(CLIENT_DATA).getContent()
          });
          commit("SET_CATALOG", {
            client_id: client_id,
            catalog: result.getOperation("CATALOG_LIST").getContent()
          });
          dispatch("addDocument", initParams);

          commit("LOADED_SUCCESS");
          resolve(null);
        })
        .catch((error: any) => {
          console.log("error", error);
          commit("LOADED_ERROR");
          reject();
        });
    });
  },

  addDocument({ commit, rootState, state }, initParams) {
    const client_id = initParams.client_id
      ? initParams.client_id
      : (rootState as any).ubic.actor.document.client_id;
    const prev_products = initParams.products
      ? initParams.products.reduce((prev: any, item: any) => {
          prev[item.product_container_id] = item;
          return prev;
        }, {})
      : {};
    initParams.deal_client_id = client_id;
    commit("ADD_DOCUMENT", {
      initParams,
      defs: {
        created_id: (rootState as any).ubic.actor.document.id,
        products: state.catalog[client_id].map((item: any) => {
          const new_item = Object.assign(
            {
              container_quantity: 0,
              container_weight: 0,
              notes: ""
            },
            item,
            {
              ...(prev_products[item.product_container_id] || {})
            }
          );
          delete new_item.id;
          return new_item;
        })
      }
    });
  },
  addProduct({ commit }, index) {
    commit("ADD_PRODUCT", { index });
  },
  removeDocument({ commit }, index) {
    console.log(index);
    commit("REMOVE_DOCUMENT", { index });
  },
  removeProduct({ commit }, { index, idx }) {
    console.log(index);
    commit("REMOVE_PRODUCT", { index, idx });
  },
  changeValue({ commit }, { index, field, newValue }) {
    commit("CHANGE_VALUE", { index, field, newValue });

    if (
      [
        "delivery_point_id",
        "expected_delivery_date",
        "type_id",
        "client_id",
        "delivery_warehouse_id"
      ].includes(field)
    ) {
      if (
        !state.documents[index].client_id ||
        !state.documents[index].expected_delivery_date ||
        !state.documents[index].delivery_point_id ||
        !state.documents[index].delivery_warehouse_id
      ) {
        return;
      }

      commit("START_ASYNC_VALIDATION");

      const vm = (this as any)._vm;

      vm.$db([
        vm
          .$q("CHECK_DEAL_EXIST")
          .raw("documents.list")
          .action({
            columns: {
              id: "deal.id",
              expected_delivery_date: "deal.expected_delivery_date"
            },

            from: "s:deals",
            from_as: "deal",
            joins: [
              {
                join: "s:statuses",
                type: "left",
                as: "status",
                on: { $eq: ["status.id", "deal.status_id"] }
              }
            ],
            where: {
              $and: [
                ...(state.documents[index].id
                  ? [
                      {
                        $not: [
                          {
                            $eq: ["deal.id", { $: state.documents[index].id }]
                          }
                        ]
                      }
                    ]
                  : []),
                {
                  $eq: [
                    "deal.client_id",
                    { $: state.documents[index].client_id }
                  ]
                },
                {
                  $eq: [
                    "deal.delivery_warehouse_id",
                    { $: state.documents[index].delivery_warehouse_id }
                  ]
                },
                {
                  $eq: [
                    "deal.delivery_point_id",
                    { $: state.documents[index].delivery_point_id }
                  ]
                },
                {
                  $and: [
                    {
                      $eq: [
                        "deal.type_id",
                        { $: state.documents[index].type_id }
                      ]
                    },
                    {
                      $not: [
                        { $eq: ["deal.type_id", { $: "d:deals_types:4" }] }
                      ]
                    }
                  ]
                },
                {
                  $eq: [
                    "deal.expected_delivery_date",
                    {
                      $: moment(
                        state.documents[index].expected_delivery_date
                      ).format("YYYY-MM-DD")
                    }
                  ]
                }
                // { $null: ['status.final'] },
              ]
            }
          })
      ]).then((result: ServerResult) => {
        const docs = result.getOperation("CHECK_DEAL_EXIST").getContent()
          .documents;
        console.log("docs.length > 0", docs.length > 0);

        const specialOrders = !!(state.client && state.client.special_orders);
        if (specialOrders) {
          if (process.env.NODE_ENV === "development") {
            console.debug("[deal-dup-check] skip", {
              clientId: state.documents[index].client_id,
              specialOrders: true,
              reason: "special_orders"
            });
          }
          commit("SET_ASYNC_ERROR", []);
          return;
        }

        const dubl_docs = Object.values(
          state.documents.reduce((prev: any, item: any) => {
            const key =
              item.client_id +
              "-" +
              item.delivery_point_id +
              "-" +
              item.delivery_warehouse_id +
              "-" +
              item.delivery_warehouse_id +
              "-" +
              moment(item.expected_delivery_date).format("YYYY-MM-DD");
            if (!prev[key]) {
              prev[key] = 0;
            }
            prev[key] += 1;
            return prev;
          }, {})
        ).filter((item: any) => {
          return item > 1;
        });

        if (docs.length) {
          console.info("[deal-dup-check] blocked", {
            clientId: state.documents[index].client_id,
            found: docs.length
          });
          commit("SET_ASYNC_ERROR", [
            "В базе уже имеется заявка в указанную точку доставки на указанную дату доставки!"
          ]);
        } else if (dubl_docs.length) {
          commit("SET_ASYNC_ERROR", [
            "Вы пытаетесь сделать несколько заявок на одну точку доставки на указанную дату доставки!"
          ]);
        } else {
          commit("SET_ASYNC_ERROR", []);
        }
      });
    }
  },
  changeProductValue({ commit }, { index, idx, field, newValue }) {
    commit("CHANGE_PRODUCT_VALUE", { index, idx, field, newValue });
  },

  changeCatalogValue({ commit }, { index, idx, field, newValue }) {
    switch (field) {
      default:
        commit("CHANGE_CATALOG_VALUE", { index, idx, field, newValue });
    }
  },

  saveClient({ state }) {
    const vm = (this as any)._vm;

    return new Promise((resolve, reject) => {
      vm.$db([
        vm.$q("CLIENT_UPDATE").update(state.client.id, {
          lk_selected_calc_method: state.client.lk_selected_calc_method
        })
      ]);
    });
  },

  saveForm({ state, commit, dispatch }) {
    commit("START_LOADING");
    const vm = (this as any)._vm;
    const allowedFields = [
      "id",
      "deal_id",
      "container_quantity",
      "container_weight",
      "is_sample",
      "is_approved",
      "container_price",
      "product_container_id",
      "notes",
      "approve_comment",
      "sample_date"
    ];

    return new Promise((resolve, reject) => {
      const documents = state.documents.map((item: any, idx: number) => {
        if (item.deal_client_id) {
          item.client_id = item.deal_client_id;
          item.name = item.deal_client_name;
        }

        const normalizedForm = state.schema.fields.reduce(
          (prev: any, field: any) => {
            const fieldName = field.code;

            if (item[fieldName]) {
              switch (field.type) {
                case "date": {
                  prev[fieldName] = moment(item[fieldName])
                    .utc()
                    .local()
                    .format("YYYY-MM-DD");
                  break;
                }
                case "timestamp":
                case "datetime": {
                  prev[fieldName] = moment(item[fieldName])
                    .utc()
                    .local()
                    .format("YYYY-MM-DD hh:mm:ss");
                  break;
                }
                default: {
                  prev[fieldName] = item[fieldName];
                }
              }
            }
            return prev;
          },
          {}
        );
        if (item.deal_client_id) {
          normalizedForm.client_id = item.deal_client_id;
          normalizedForm.name = item.deal_client_name;
        }
        return vm.$q("DEAL-" + idx).create("s:deals", normalizedForm);
      });
      vm.$db(documents).then((result: ServerResult) => {
        result.getOperationNames().map((opName: any) => {
          const deal = result.getOperation(opName).getContent().document;
          console.log(deal);
          opName = parseInt(opName.split("-")[1]);

          const normalizedItemsData = state.documents[opName].products
            .filter((item: any) => {
              return item.container_quantity > 0;
            })
            .map((item: any) => {
              const cleanDocuemnt: any = Object.keys(item)
                .filter((key: string) => allowedFields.includes(key))
                .reduce((obj: any, key: string) => {
                  obj[key] = item[key];
                  return obj;
                }, {});

              cleanDocuemnt.container_weight =
                parseFloat(`${item.container_weight}`.replace(" ", "")) + "";
              cleanDocuemnt.container_price =
                parseFloat(`${item.container_price}`.replace(" ", "")) + "";
              if (cleanDocuemnt.sample_date) {
                cleanDocuemnt.sample_date = moment(
                  cleanDocuemnt.sample_date
                ).format("YYYY-MM-DD");
              }
              return cleanDocuemnt;
            });
          const queries = [
            vm
              .$q(`SAVE_DEAL_BASKET`)
              .update(deal.id, {})
              .createManyRelation(
                "deal_product_containers",
                "deal_id",
                (createRelated: any) => {
                  return normalizedItemsData
                    .filter((item: any) => !item.id)
                    .map((item: any) => createRelated(item));
                }
              )
          ];

          vm.$db(queries).then((result: ServerResult) => {
            const totalSaveRes = !result
              .getOperation(`SAVE_DEAL_BASKET`)
              .hasError();
            if (totalSaveRes) {
              commit("LOADED_SUCCESS");
              resolve(null);
            } else {
              commit("LOADED_ERROR");
              reject();
            }
          });
        });
      });
    });
  }
};

export const mutations: MutationTree<OrdersNewState> = {
  START_LOADING: state => {
    state.loaded = false;
    state.loading = true;
    state.fatalError = false;
  },
  LOADED_SUCCESS: state => {
    state.loaded = true;
    state.loading = false;
    state.fatalError = false;
  },
  LOADED_ERROR: state => {
    state.loaded = true;
    state.loading = false;
    state.fatalError = true;
  },

  SET_SCHEMA: (state, { schema, client, catalog }) => {
    state.schema = schema.schema;
    state.client = client.document;
    state.documents = [];
  },

  SET_HOLYDAYS: (state, { documents }) => {
    state.holydays = documents.reduce((acc: any, item: any) => {
      if (!acc[item.delivery_zone_id]) {
        acc[item.delivery_zone_id] = [];
      }
      acc[item.delivery_zone_id].push(moment(item.date).toDate());
      return acc;
    }, {});
  },

  SET_CATALOG: (state, { client_id, catalog }) => {
    const catalog_rows: any[] = [];
    catalog.documents.map((item: any) => {
      item.containers = item.containers.map((i: any) => {
        catalog_rows.push({
          product_name: item.product_name,
          promo_name: item.promo_name,
          product_container_id: i.id,
          base_price: parseFloat(i.container_price),
          base_weight: parseFloat(i.container_weight),
          ...i,
          container_price: 0,
          container_weight: 0,
          unit_quantity: 0
        });
      });
    });
    state.catalog[client_id] = catalog_rows;
    const prev_documents: any[] = state.documents.reduce(
      (prev: any, doc: any) => {
        prev.push(
          doc.products
            .map((item: any) => {
              return {
                key: item.product_container_id,
                container_quantity: item.container_quantity,
                container_price: item.container_price,
                container_weight: item.container_weight,
                unit_quantity: item.unit_quantity
              };
            })
            .reduce((acc: any, item: any) => {
              acc[item.key] = item;
              return acc;
            }, {})
        );
        return prev;
      },
      []
    );

    state.documents.map((doc: any, idx: number) => {
      doc.products = state.catalog[doc.deal_client_id].map((item: any) => {
        const _prev = prev_documents[idx][item.product_container_id]
          ? prev_documents[idx][item.product_container_id]
          : { container_quantity: 0, container_weight: 0, container_price: 0 };
        const new_item = Object.assign(
          {
            notes: ""
          },
          item,
          {
            container_quantity: _prev.container_quantity,
            unit_quantity: _prev.unit_quantity,
            container_weight: _prev.container_weight,
            container_price: _prev.container_price,
            notes: ""
          }
        );
        delete new_item.id;
        return new_item;
      });
    });
  },
  REMOVE_DOCUMENT: (state, { index }) => {
    state.documents.splice(index, 1);
  },
  REMOVE_PRODUCT: (state, { index, idx }) => {
    state.documents[index].products.splice(idx, 1);
  },
  ADD_PRODUCT: (state, { index }) => {
    state.documents[index].products.push({
      product_id: null,
      product_container_id: null,
      container_quantity: 0,
      container_weight: 0,
      base_price: 0,
      base_weight: 0,
      notes: ""
    });
  },
  ADD_DOCUMENT: (state, { initParams, defs }) => {
    const formData = state.schema.fields.reduce((prev: any, field: any) => {
      if (initParams[field.code]) {
        if (["date", "datetime"].includes(field.type)) {
          prev[field.code] = moment(initParams[field.code]).toDate();
        } else {
          prev[field.code] = initParams[field.code];
        }
      } else if (defs[field.code]) {
        if (["date", "datetime"].includes(field.type)) {
          prev[field.code] = moment(defs[field.code]).toDate();
        } else {
          prev[field.code] = defs[field.code];
        }
      } else {
        prev[field.code] = null;
      }

      return prev;
    }, {});
    formData.type_id = "d:deals_types:1";
    formData.status_id = "d:statuses:13";
    formData.source = "lk";
    formData.client_id = state.client.id;
    formData.deal_client_id = initParams.deal_client_id;
    formData.client_type_id = state.client.type_id;
    formData.manager_id = state.client.manager_id;
    formData.name = state.client.name;
    formData.delivery_warehouse_id = state.client.delivery_warehouse_id;
    formData.products = defs.products ? defs.products : [];
    state.documents.push(formData);
  },

  CHANGE_VALUE(state, { index, field, newValue }) {
    console.log(index, field, newValue);
    switch (field) {
      default:
        state.documents[index][field] = newValue;
    }
  },

  CHANGE_CATALOG_VALUE(state, { index, idx, field, newValue }) {
    console.log(index, idx, field, newValue);

    switch (field) {
      default:
        state.catalog[idx].containers[index][field] = newValue;
    }
  },

  CHANGE_PRODUCT_VALUE(state, { index, idx, field, newValue }) {
    console.log(index, idx, field, newValue);
    switch (field) {
      case "unit_quantity":
        state.documents[index].products[idx].unit_quantity = parseFloat(
          newValue
        );
        state.documents[index].products[idx].container_quantity =
          Math.ceil(
            state.documents[index].products[idx].unit_quantity /
              state.documents[index].products[idx].base_weight
          ) || 1;

        state.documents[index].products[idx].container_weight =
          state.documents[index].products[idx].container_quantity *
          state.documents[index].products[idx].base_weight;
        if (!state.documents[index].products[idx].unit_quantity) {
          state.documents[index].products[idx].container_weight = 0;
          state.documents[index].products[idx].container_quantity = 0;
        }
        break;
      case "container_quantity":
        state.documents[index].products[idx].container_quantity = parseInt(
          newValue
        );
        state.documents[index].products[idx].unit_quantity =
          parseInt(newValue) *
          (state.documents[index].products[idx].price_per_kg
            ? 1
            : state.documents[index].products[idx].base_weight);
        if (!state.documents[index].products[idx].container_weight) {
          state.documents[index].products[idx].container_weight =
            parseInt(newValue) *
            (state.documents[index].products[idx].price_per_kg
              ? 1
              : state.documents[index].products[idx].base_weight);
        } else if (!state.documents[index].products[idx].container_quantity) {
          state.documents[index].products[idx].container_weight = 0;
          state.documents[index].products[idx].unit_quantity = 0;
        }
        break;
      case "container_weight":
        state.documents[index].products[idx].container_weight = parseFloat(
          newValue
        );
        if (!state.documents[index].products[idx].container_quantity) {
          state.documents[index].products[idx].container_quantity = 1;
        } else if (!state.documents[index].products[idx].container_weight)
          state.documents[index].products[idx].container_quantity = 0;
        state.documents[index].products[idx].unit_quantity = 0;
        break;
      default:
        state.documents[index].products[idx][field] = newValue;
    }
    state.documents[index].products[idx].container_price =
      Math.round(
        100 *
          state.documents[index].products[idx].base_price *
          state.documents[index].products[idx].container_quantity *
          (state.documents[index].products[idx].price_per_kg
            ? state.documents[index].products[idx].container_weight
            : state.documents[index].products[idx].base_weight)
      ) / 100;
  },
  START_ASYNC_VALIDATION: state => {
    state.asyncValidationLoading = true;
  },
  SET_ASYNC_ERROR: (state, errors: any[]) => {
    state.asyncValidationLoading = false;
    state.hasAsyncError = errors.length > 0;
    state.asyncErrors = errors;
  }
};

export const getters: GetterTree<OrdersNewState, RootState> = {
  total: (state: OrdersNewState) => {
    const total = state.documents.reduce((prev: any, item: any) => {
      const products = item.products.reduce(
        (pprev: any, pitem: any) => {
          console.log(pitem);
          pprev.weight += pitem.price_per_kg
            ? parseFloat(pitem.container_weight)
            : pitem.base_weight * parseFloat(pitem.container_quantity);
          pprev.sum += parseFloat(pitem.container_price);
          pprev.quantity += parseFloat(pitem.container_quantity);
          return pprev;
        },
        {
          sum: 0,
          quantity: 0,
          weight: 0
        }
      );
      prev.push(products);
      return prev;
    }, []);
    return total;
  }
};

export const STORE_KEY = "$_order_new";

export const store = {
  namespaced: true,
  state,
  actions,
  getters,
  mutations
};
